import initializeIziButton from "./initializeIziButton";
import refreshMinicartIziButton from "./refreshMinicartIziButton";

let inpostPayButtonClicked = false;
let widgetInitialized = false;
let observerInitialized = false;

export default async function refreshIziButton() {
  const isCartPage =
    document.body.classList.contains("woocommerce-cart") ||
    document.querySelector(".woocommerce-cart-form") ||
    document.querySelector(".cart_totals") ||
    document.querySelector("div.wp-block-woocommerce-cart");

  refreshMinicartIziButton();

  if (!isCartPage) return;

  if (IPPWidgetOptions.isBlock === "true") {
    if (window.wp) {
      const CART_STORE_KEY = "wc/store/cart";

      let previousCartData = null;

      window.wp.data.subscribe(() => {
        try {
          const cartStore = window.wp.data.select(CART_STORE_KEY);
          if (cartStore) {
            const cartData = cartStore.getCartData();
            const cartTotals = cartStore.getCartTotals();

            const currentCartData = {
              itemCount: cartData?.items?.length || 0,
              total: cartTotals?.total_price || 0,
              itemsWeight: cartData?.itemsWeight || 0,
              coupons: cartData?.coupons?.length || 0,
            };

            if (
              previousCartData &&
              JSON.stringify(previousCartData) !==
                JSON.stringify(currentCartData)
            ) {
              console.log("Cart data changed");
              if (!inpostPayButtonClicked) {
                widgetInitialized = false;
                initWidgetIfNeeded();
              }
            }

            previousCartData = currentCartData;
          }
        } catch (error) {
          console.warn("Error:", error);
        }
      });
    }
  } else {
    jQuery(document.body).on("wc_fragments_refreshed", function () {
      const popup = document.querySelector("#inpostpay-widget-popup");

      if (inpostPayButtonClicked) {
        return;
      }

      widgetInitialized = false;

      if (!popup && !widgetInitialized) {
        waitForPopup(30, 250)
          .then(() => {
            initWidgetIfNeeded();
          })
          .catch(() => {
            initWidgetIfNeeded();
          });
      }
    });

    // Hooks that render inside div.cart_totals - the WooCommerce fragment refreshed
    // on shipping method changes. Placements outside this area (e.g. woocommerce_before_cart,
    // woocommerce_after_cart) are static and don't need re-init after shipping update.
    const CART_TOTALS_HOOKS = [
      "woocommerce_cart_collaterals",
      "woocommerce_before_cart_totals",
      "woocommerce_cart_totals_before_shipping",
      "woocommerce_before_shipping_calculator",
      "woocommerce_after_shipping_calculator",
      "woocommerce_cart_totals_after_shipping",
      "woocommerce_cart_totals_before_order_total",
      "woocommerce_cart_totals_after_order_total",
      "woocommerce_proceed_to_checkout",
      "woocommerce_after_cart_totals",
    ];

    const cartPlacement = (IPPWidgetOptions.cartWidgetPlacement || "").trim();
    if (CART_TOTALS_HOOKS.includes(cartPlacement)) {
      jQuery(document).ajaxComplete(function (event, xhr, settings) {
        if (
          settings.url &&
          settings.url.includes("update_shipping_method") &&
          !inpostPayButtonClicked
        ) {
          widgetInitialized = false;
          initWidgetIfNeeded();
        }
      });
    }
  }

  if (!observerInitialized) {
    observerInitialized = true;

    document.addEventListener("click", async (e) => {
      const target = e.target.closest("inpost-izi-button");
      if (!target) return;

      inpostPayButtonClicked = true;

      try {
        await waitForPopup(8, 250);
        await waitForButtonConnect();
      } catch (err) {
        const popup = document.querySelector("#inpostpay-widget-popup");
        const iziButtonExists = document.querySelector("inpost-izi-button");

        const shouldForceInit = !popup && !iziButtonExists;

        if (shouldForceInit) {
          initWidgetIfNeeded();
        }
      }
    });

    jQuery(document.body).on("wc_fragments_refreshed", () => {
      if (!inpostPayButtonClicked) {
        initWidgetIfNeeded();
      }
    });

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.removedNodes.forEach((node) => {
          if (node.id === "inpostpay-widget-popup") {
            inpostPayButtonClicked = false;
            widgetInitialized = false;

            if (document.body.classList.contains("woocommerce-cart")) {
              waitForPopup(30, 250)
                .then(() => {
                  initWidgetIfNeeded();
                })
                .catch(() => {
                  initWidgetIfNeeded();
                });
            }

            if (!document.querySelector("inpost-izi-button")) {
              waitForPopup(30, 250)
                .then(() => {
                  initWidgetIfNeeded();
                })
                .catch(() => {
                  initWidgetIfNeeded();
                });
            }

            setTimeout(() => {
              if (
                !document.querySelector("#inpostpay-widget-popup") &&
                !widgetInitialized
              ) {
                initWidgetIfNeeded();
              }
            }, 1000);
          }
        });
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
}

function initWidgetIfNeeded() {
  const popup = document.querySelector("#inpostpay-widget-popup");
  const popupExists = !!popup;
  const widgetExistsInDOM = document.querySelector("inpost-izi-button");

/*
  if (typeof window.IPPWidgetOptions === "undefined") {
    const configScript = document.querySelector('script[data-ippwidget-options]');
    if (configScript) {
      try {
        window.IPPWidgetOptions = JSON.parse(configScript.textContent);
        console.log("[InPost] Restored IPPWidgetOptions from script tag after WooCommerce refresh");
      } catch (err) {
        console.warn("[InPost] Failed to parse IPPWidgetOptions:", err);
      }
    } else {
      console.warn("[InPost] IPPWidgetOptions still missing after refresh");
    }
  } */

  if (!popupExists && !widgetInitialized && !widgetExistsInDOM) {
    window.IPPwidget = InPostPayWidget.init(IPPWidgetOptions);
    initializeIziButton();
    widgetInitialized = true;
  }
}

function waitForPopup(maxRetries = 20, delay = 250) {
  return new Promise((resolve, reject) => {
    let attempts = 0;
    const interval = setInterval(() => {
      const popup = document.querySelector("#inpostpay-widget-popup");
      if (popup) {
        clearInterval(interval);
        resolve(popup);
      } else if (++attempts >= maxRetries) {
        clearInterval(interval);
        reject(new Error("Popup nie pojawił się w czasie"));
      }
    }, delay);
  });
}

function waitForButtonConnect(maxRetries = 20, delay = 300) {
  return new Promise((resolve, reject) => {
    let attempts = 0;
    const interval = setInterval(() => {
      const popup = document.querySelector("#inpostpay-widget-popup");
      const shadow = popup?.shadowRoot;
      const button = shadow?.querySelector("#button-connect");

      if (button) {
        clearInterval(interval);
        resolve(button);
      } else if (++attempts >= maxRetries) {
        clearInterval(interval);
      }
    }, delay);
  });
}
